import { injectCpoApi } from '@delmonicos/shared-sdk/libs/emsp/src/clients/redux/back-office/cpo.service';
import { baseApi } from '@service/base.api';

export const cpoApi = injectCpoApi(baseApi);

export const { useGetCposQuery, useGetCpoByIdQuery } = cpoApi;
